<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
    <v-btn
        prepend-icon="Trash"
        variant="text"
        size="small"
        color="primary"
        class="delete-session-buton"
    >
        <span class="delete-session-buton__label">
            {{ t('sessions.delete_device') }}
        </span>
    </v-btn>
</template>

<style>
    .delete-session-buton {
        text-transform: initial;

        &__label {
            @media(max-width: 600px) {
                display: none;
            }
        }
    }
</style>
